import _ from 'lodash';

import PropTypes from 'prop-types';

import { FadeInAnimation } from '../../shared';

const BuildingLocation = (props) => {
    
    const { selectedBuilding, buildingContentCMS } = props;
    
    const iconSrc = _.get(buildingContentCMS, 'fields.map_pin_icon');
    const longitude = _.get(selectedBuilding, 'address.longitude');
    const latitude = _.get(selectedBuilding, 'address.latitude');

    return (
        <FadeInAnimation>
            <div id="location-section">
                <h3 className='building-location-header3'>Location</h3>
                <p className='building-location-details'>
                    Centrally located in the heart of the CBD, close to all major taxi routes, HOMii
                    is where it&apos;s all happening!
                </p>

                <a className='building-location-anchor-tag'
                    href={`//www.google.com/maps/search/?api=1&query=${latitude},${longitude}`}
                    rel="noreferrer"
                    target="_blank"
                >
                    <img
                        src={`https://maps.googleapis.com/maps/api/staticmap?center=${latitude},${longitude}&zoom=15&size=900x400
                                &markers=icon:${iconSrc}|${latitude},${longitude}&key=AIzaSyB4ee6dZHAKJYXn06J8pP-nu0DlHfuvtsY`}
                        alt="google-map"
                        width="100%"
                        className='building-location-img'
                    />
                </a>
            </div>
        </FadeInAnimation>
    );
};

export default BuildingLocation;

BuildingLocation.propTypes = {
    selectedBuilding: PropTypes.object,
    buildingContentCMS: PropTypes.object,
};

